import { render } from "./PurchaseDetailsModal.vue?vue&type=template&id=1718dd7c&scoped=true"
import script from "./PurchaseDetailsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailsModal.vue?vue&type=script&lang=js"

import "./PurchaseDetailsModal.vue?vue&type=style&index=0&id=1718dd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1718dd7c"]])

export default __exports__